module.exports = __webpack_public_path__ + "static/media/canvas_measure_active.da9814f7.svg";